import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./lib/auth";

// After a Cloudflare redeploy the user's cached index.html points at
// chunk hashes that no longer exist on the CDN. Vite emits a
// `vite:preloadError` event when a lazy-import (i.e. one of the
// code-split pages we added) fails to fetch — the symptom is a blank
// screen at /i140-intake / /letter-studio / etc. because the
// Suspense fallback waits on a chunk that 404s. Hard-reload to pick
// up the new index.html + chunk hashes. The `preventDefault` keeps
// React from also surfacing the error to the user.
const RELOAD_KEY = "vg-preload-reload-at";
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  // Guard against an infinite reload loop on a genuinely broken
  // deploy: only reload at most once per 10s.
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < 10_000) return;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch { /* sessionStorage unavailable — reload anyway */ }
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
